import { LANGUAGE_SWITCHER_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[LANGUAGE_SWITCHER_MODULE_ID]: {
		moduleType: 'misc',
		miscModuleType: 'languageSwitcherModule',
	},
}
